import {useCallback, useEffect, useMemo} from 'react'
import {Form, FormInstance} from 'antd'
import {TransactionType} from '@/types/transactions'
import {DEFAULT_CURRENCY} from '@/constants/currencies'
import {MerchantTerminalDataType} from '@/stores/pay-by-link/models/MerchantTerminalDataType'

export function usePblCommon(
    form: FormInstance,
    terminals: {value: string; data?: MerchantTerminalDataType}[]
) {
    const txType = Form.useWatch('transactionType', form)

    const isVerificationFlag = useMemo(() => txType === TransactionType.VERIFICATION, [txType])
    const isVerification = useCallback(() => isVerificationFlag, [isVerificationFlag])

    const getTerminalData = useCallback(
        (terminalId = form.getFieldValue('terminalId')): MerchantTerminalDataType => {
            const terminal = terminals.find((t) => t.value === terminalId)?.data
            return (
                terminal ?? {
                    defaultCurrency: DEFAULT_CURRENCY,
                    supportedCurrencies: [DEFAULT_CURRENCY],
                    card: {}
                }
            )
        },
        [form, terminals]
    )

    const terminalId = Form.useWatch('terminalId', form)

    useEffect(() => {
        if (terminalId === undefined) return
        const td = getTerminalData(terminalId)
        const current = form.getFieldValue('currency')
        form.setFieldsValue({
            recurring: td.card?.allowPblRecurring ? td.card?.pblRecurringByDefault : false,
            currency: td.supportedCurrencies?.includes(current) ? current : td.defaultCurrency
        })
    }, [terminalId, getTerminalData, form])

    return {isVerificationFlag, isVerification, getTerminalData}
}
